import request from "@/utils/request";

// 查询标签列表
export function getTagsList(params) {
  return request({
    url: "/admin/tags/list",
    method: "get",
    params: params
  });
}

//新增标签
export function addTags(data) {
  return request({
    url: "/admin/tags",
    method: "post",
    data: data
  });
}

//修改标签
export function updateTags(data) {
  return request({
    url: "/admin/tags",
    method: "put",
    data: data
  });
}

//删除标签
export function removeTags(data) {
  return request({
    url: "/admin/tags",
    method: "delete",
    data: data
  });
}
